import { default as Svg2022_uad_comment_icon } from './2022_uad_comment';
import { default as Svg2022_uad_comment_add_icon } from './2022_uad_comment_add';
import { default as Svg2022_uad_comment_reply_icon } from './2022_uad_comment_reply';
import { default as Svg2022_uad_metadata_icon } from './2022_uad_metadata';
import { default as Svg2022_uad_subclip_icon } from './2022_uad_subclip';
import { default as Svg2022_uad_subclip_add_icon } from './2022_uad_subclip_add';
import { default as Svg2022_uad_time_based_metadata_icon } from './2022_uad_time_based_metadata';
import { default as Svg2022_uad_timebased_metadata_add_icon } from './2022_uad_timebased_metadata_add';
import { default as academy_icon } from './academy';
import { default as access_control_icon } from './access_control';
import { default as ai_icon } from './ai';
import { default as ai_metadata_icon } from './ai_metadata';
import { default as ai_search_icon } from './ai_search';
import { default as ai_sparkles_icon } from './ai_sparkles';
import { default as analyze_icon } from './analyze';
import { default as annotation_activate_icon } from './annotation_activate';
import { default as annotation_annotation_icon } from './annotation_annotation';
import { default as annotation_arrow_icon } from './annotation_arrow';
import { default as annotation_brush_icon } from './annotation_brush';
import { default as annotation_brushsize_icon } from './annotation_brushsize';
import { default as annotation_circle_icon } from './annotation_circle';
import { default as annotation_color_palette_icon } from './annotation_color_palette';
import { default as annotation_de_activate_icon } from './annotation_de_activate';
import { default as annotation_erase_icon } from './annotation_erase';
import { default as annotation_eraser_icon } from './annotation_eraser';
import { default as annotation_laser_icon } from './annotation_laser';
import { default as annotation_line_icon } from './annotation_line';
import { default as annotation_move_icon } from './annotation_move';
import { default as annotation_pencil_icon } from './annotation_pencil';
import { default as annotation_rectangle_icon } from './annotation_rectangle';
import { default as annotation_redo_icon } from './annotation_redo';
import { default as annotation_text_icon } from './annotation_text';
import { default as annotation_undo_icon } from './annotation_undo';
import { default as archive_archive_icon } from './archive_archive';
import { default as archive_archived_icon } from './archive_archived';
import { default as archive_restore_icon } from './archive_restore';
import { default as arrow_small_e_icon } from './arrow_small_e';
import { default as arrow_small_n_icon } from './arrow_small_n';
import { default as arrow_small_s_icon } from './arrow_small_s';
import { default as arrow_small_w_icon } from './arrow_small_w';
import { default as aspect_ratio_icon } from './aspect_ratio';
import { default as asset_delete_icon } from './asset_delete';
import { default as asset_type_audio_icon } from './asset_type_audio';
import { default as asset_type_image_icon } from './asset_type_image';
import { default as asset_type_pdf_icon } from './asset_type_pdf';
import { default as asset_type_placeholder_icon } from './asset_type_placeholder';
import { default as asset_type_subclip_icon } from './asset_type_subclip';
import { default as asset_type_unknown_icon } from './asset_type_unknown';
import { default as asset_type_video_icon } from './asset_type_video';
import { default as attachment_icon } from './attachment';
import { default as automations_icon } from './automations';
import { default as background_icon } from './background';
import { default as bell_crossed_icon } from './bell_crossed';
import { default as broom_icon } from './broom';
import { default as calendar_icon } from './calendar';
import { default as calendar_datetime_icon } from './calendar_datetime';
import { default as checkmark_icon } from './checkmark';
import { default as chevron_large_isolated_e_icon } from './chevron_large_isolated_e';
import { default as chevron_large_isolated_n_icon } from './chevron_large_isolated_n';
import { default as chevron_large_isolated_s_icon } from './chevron_large_isolated_s';
import { default as chevron_large_isolated_w_icon } from './chevron_large_isolated_w';
import { default as chevron_small_isolated_e_icon } from './chevron_small_isolated_e';
import { default as chevron_small_isolated_n_icon } from './chevron_small_isolated_n';
import { default as chevron_small_isolated_s_icon } from './chevron_small_isolated_s';
import { default as chevron_small_isolated_w_icon } from './chevron_small_isolated_w';
import { default as child_icon } from './child';
import { default as close_icon } from './close';
import { default as cluster_icon } from './cluster';
import { default as collection_icon } from './collection';
import { default as collection_add_to_icon } from './collection_add_to';
import { default as collection_create_new_icon } from './collection_create_new';
import { default as collection_opened_icon } from './collection_opened';
import { default as comment_icon } from './comment';
import { default as comment_hidden_icon } from './comment_hidden';
import { default as company_dailymotion_icon } from './company_dailymotion';
import { default as company_discord_icon } from './company_discord';
import { default as company_dropbox_icon } from './company_dropbox';
import { default as company_facebook_icon } from './company_facebook';
import { default as company_instagram_icon } from './company_instagram';
import { default as company_snapchat_icon } from './company_snapchat';
import { default as company_tiktok_icon } from './company_tiktok';
import { default as company_twitch_icon } from './company_twitch';
import { default as company_twitter_icon } from './company_twitter';
import { default as company_we_transfer_icon } from './company_we_transfer';
import { default as company_x_icon } from './company_x';
import { default as company_youtube_icon } from './company_youtube';
import { default as compare_icon } from './compare';
import { default as conversation_icon } from './conversation';
import { default as copy_icon } from './copy';
import { default as credit_icon } from './credit';
import { default as custom_action_icon } from './custom_action';
import { default as deletion_clear_icon } from './deletion_clear';
import { default as deletion_delete_icon } from './deletion_delete';
import { default as deletion_erase_icon } from './deletion_erase';
import { default as deletion_remove_icon } from './deletion_remove';
import { default as dev_api_icon } from './dev_api';
import { default as display_hide_icon } from './display_hide';
import { default as display_show_icon } from './display_show';
import { default as divide_icon } from './divide';
import { default as drag_icon } from './drag';
import { default as edit_icon } from './edit';
import { default as email_icon } from './email';
import { default as email_error_icon } from './email_error';
import { default as emoji_icon } from './emoji';
import { default as enter_icon } from './enter';
import { default as face_recognition_icon } from './face_recognition';
import { default as fail_icon } from './fail';
import { default as favorite_assets_icon } from './favorite_assets';
import { default as favorite_collections_icon } from './favorite_collections';
import { default as favorite_saved_searches_icon } from './favorite_saved_searches';
import { default as favorites_add_to_icon } from './favorites_add_to';
import { default as favorites_added_to_icon } from './favorites_added_to';
import { default as file_icon } from './file';
import { default as file_export_icon } from './file_export';
import { default as file_proxy_icon } from './file_proxy';
import { default as filter_icon } from './filter';
import { default as fit_actual_size_icon } from './fit_actual_size';
import { default as fit_height_icon } from './fit_height';
import { default as fit_viewport_icon } from './fit_viewport';
import { default as fit_width_icon } from './fit_width';
import { default as folder_icon } from './folder';
import { default as fr_change_person_icon } from './fr_change_person';
import { default as gallery_icon } from './gallery';
import { default as globe_icon } from './globe';
import { default as go_to_icon } from './go_to';
import { default as help_description_icon } from './help_description';
import { default as help_tooltip_icon } from './help_tooltip';
import { default as history_icon } from './history';
import { default as home_icon } from './home';
import { default as iconik_agent_icon_icon } from './iconik_agent_icon';
import { default as iconik_shield_icon } from './iconik_shield';
import { default as id_icon } from './id';
import { default as image_add_icon } from './image_add';
import { default as index_icon_icon } from './index_icon';
import { default as ip_address_icon } from './ip_address';
import { default as isg_icon } from './isg';
import { default as isg_pro_icon } from './isg_pro';
import { default as jobs_icon } from './jobs';
import { default as key_icon } from './key';
import { default as keyboard_icon } from './keyboard';
import { default as language_icon } from './language';
import { default as link_icon } from './link';
import { default as link_add_icon } from './link_add';
import { default as load_down_icon } from './load_down';
import { default as load_up_icon } from './load_up';
import { default as loader_circle_done_legacy_icon } from './loader_circle_done_legacy';
import { default as log_in_icon } from './log_in';
import { default as log_out_icon } from './log_out';
import { default as megaphone_icon } from './megaphone';
import { default as mention_icon } from './mention';
import { default as menu_context_icon } from './menu_context';
import { default as menu_hamburger_icon } from './menu_hamburger';
import { default as message_error_icon } from './message_error';
import { default as message_success_icon } from './message_success';
import { default as message_warning_icon } from './message_warning';
import { default as metadata_dropdown_icon } from './metadata_dropdown';
import { default as metadata_float_icon } from './metadata_float';
import { default as metadata_integer_icon } from './metadata_integer';
import { default as metadata_text_icon } from './metadata_text';
import { default as metadata_text_area_icon } from './metadata_text_area';
import { default as minus_icon } from './minus';
import { default as money_billing_icon } from './money_billing';
import { default as money_credit_card_icon } from './money_credit_card';
import { default as money_invoice_icon } from './money_invoice';
import { default as money_top_up_icon } from './money_top_up';
import { default as money_transaction_icon } from './money_transaction';
import { default as money_wallet_icon } from './money_wallet';
import { default as moon_icon } from './moon';
import { default as move_icon } from './move';
import { default as move_bottom_icon } from './move_bottom';
import { default as move_top_icon } from './move_top';
import { default as node_icon } from './node';
import { default as not_modified_icon } from './not_modified';
import { default as notification_icon } from './notification';
import { default as open_icon } from './open';
import { default as padlock_locked_icon } from './padlock_locked';
import { default as padlock_unlocked_icon } from './padlock_unlocked';
import { default as page_first_horizontally_icon } from './page_first_horizontally';
import { default as page_last_horizontally_icon } from './page_last_horizontally';
import { default as page_number_icon } from './page_number';
import { default as pages_icon } from './pages';
import { default as pending_icon } from './pending';
import { default as pin_icon } from './pin';
import { default as player_flip_horizontally_icon } from './player_flip_horizontally';
import { default as player_flop_vertically_icon } from './player_flop_vertically';
import { default as player_loop_icon } from './player_loop';
import { default as player_loop_pingpong_icon } from './player_loop_pingpong';
import { default as player_marker_icon } from './player_marker';
import { default as player_mixer_icon } from './player_mixer';
import { default as player_pan_icon } from './player_pan';
import { default as player_pause_icon } from './player_pause';
import { default as player_play_icon } from './player_play';
import { default as player_playback_options_icon } from './player_playback_options';
import { default as player_playback_speed_icon } from './player_playback_speed';
import { default as player_time_format_icon } from './player_time_format';
import { default as player_view_full_icon } from './player_view_full';
import { default as player_view_normal_icon } from './player_view_normal';
import { default as player_volume_max_icon } from './player_volume_max';
import { default as player_volume_meter_icon } from './player_volume_meter';
import { default as player_volume_mid_icon } from './player_volume_mid';
import { default as player_volume_no_icon } from './player_volume_no';
import { default as player_zoom_in_icon } from './player_zoom_in';
import { default as player_zoom_out_icon } from './player_zoom_out';
import { default as playlist_icon } from './playlist';
import { default as plus_icon } from './plus';
import { default as portal_icon } from './portal';
import { default as portal_new_icon } from './portal_new';
import { default as poster_icon } from './poster';
import { default as present_icon } from './present';
import { default as printer_icon } from './printer';
import { default as project_icon } from './project';
import { default as protected_icon } from './protected';
import { default as ra_icon } from './ra';
import { default as ra_approval_requested_icon } from './ra_approval_requested';
import { default as ra_approval_requested_to_me_icon } from './ra_approval_requested_to_me';
import { default as ra_approved_icon } from './ra_approved';
import { default as ra_approved_by_me_icon } from './ra_approved_by_me';
import { default as ra_rejected_icon } from './ra_rejected';
import { default as ra_rejected_by_me_icon } from './ra_rejected_by_me';
import { default as range_in_point_icon } from './range_in_point';
import { default as range_out_point_icon } from './range_out_point';
import { default as range_range_icon } from './range_range';
import { default as recent_icon } from './recent';
import { default as recent_assets_icon } from './recent_assets';
import { default as recent_collections_icon } from './recent_collections';
import { default as refresh_icon } from './refresh';
import { default as relations_icon } from './relations';
import { default as reorder_icon } from './reorder';
import { default as reply_icon } from './reply';
import { default as reset_icon } from './reset';
import { default as revert_icon } from './revert';
import { default as role_groups_icon } from './role_groups';
import { default as rotate_clockwise_icon } from './rotate_clockwise';
import { default as rotate_counter_clockwise_icon } from './rotate_counter_clockwise';
import { default as saved_search_icon } from './saved_search';
import { default as search_icon } from './search';
import { default as segment_go_to_icon } from './segment_go_to';
import { default as selection_items_icon } from './selection_items';
import { default as selection_items_all_icon } from './selection_items_all';
import { default as selection_text_icon } from './selection_text';
import { default as send_icon } from './send';
import { default as sequence_icon } from './sequence';
import { default as settings_icon } from './settings';
import { default as share_icon } from './share';
import { default as share_by_me_icon } from './share_by_me';
import { default as share_with_me_icon } from './share_with_me';
import { default as sidebar_below_icon } from './sidebar_below';
import { default as sidebar_right_icon } from './sidebar_right';
import { default as smartphone_icon } from './smartphone';
import { default as snapshot_icon } from './snapshot';
import { default as sort_icon } from './sort';
import { default as sort_newest_icon } from './sort_newest';
import { default as sort_oldest_icon } from './sort_oldest';
import { default as star_fill_icon } from './star_fill';
import { default as statistics_icon } from './statistics';
import { default as status_generic_icon } from './status_generic';
import { default as storage_cloud_icon } from './storage_cloud';
import { default as storage_on_premise_icon } from './storage_on_premise';
import { default as subtitles_icon } from './subtitles';
import { default as sum_icon } from './sum';
import { default as sun_icon } from './sun';
import { default as sync_icon } from './sync';
import { default as sync_paused_icon } from './sync_paused';
import { default as tag_icon } from './tag';
import { default as tasks_icon } from './tasks';
import { default as terms_icon } from './terms';
import { default as text_blockquote_icon } from './text_blockquote';
import { default as text_bold_icon } from './text_bold';
import { default as text_editor_icon } from './text_editor';
import { default as text_italic_icon } from './text_italic';
import { default as text_list_bullet_icon } from './text_list_bullet';
import { default as text_list_number_icon } from './text_list_number';
import { default as text_strikethrough_icon } from './text_strikethrough';
import { default as text_underscore_icon } from './text_underscore';
import { default as tier_enterprise_icon } from './tier_enterprise';
import { default as toggle_on_icon } from './toggle_on';
import { default as transcoder_icon } from './transcoder';
import { default as transcription_icon } from './transcription';
import { default as transfer_icon } from './transfer';
import { default as translucent_icon } from './translucent';
import { default as transparency_icon } from './transparency';
import { default as upgrade_icon } from './upgrade';
import { default as user_add_icon } from './user_add';
import { default as user_group_icon } from './user_group';
import { default as user_type_browse_icon } from './user_type_browse';
import { default as user_type_power_icon } from './user_type_power';
import { default as user_type_standard_icon } from './user_type_standard';
import { default as user_user_icon } from './user_user';
import { default as versions_icon } from './versions';
import { default as versions_add_new_icon } from './versions_add_new';
import { default as video_highlight_icon } from './video_highlight';
import { default as view_grid_icon } from './view_grid';
import { default as view_list_icon } from './view_list';
import { default as webhook_icon } from './webhook';
export const icons = {
  Svg2022_uad_comment: Svg2022_uad_comment_icon,
  Svg2022_uad_comment_add: Svg2022_uad_comment_add_icon,
  Svg2022_uad_comment_reply: Svg2022_uad_comment_reply_icon,
  Svg2022_uad_metadata: Svg2022_uad_metadata_icon,
  Svg2022_uad_subclip: Svg2022_uad_subclip_icon,
  Svg2022_uad_subclip_add: Svg2022_uad_subclip_add_icon,
  Svg2022_uad_time_based_metadata: Svg2022_uad_time_based_metadata_icon,
  Svg2022_uad_timebased_metadata_add: Svg2022_uad_timebased_metadata_add_icon,
  ip_address: ip_address_icon,
  isg: isg_icon,
  academy: academy_icon,
  access_control: access_control_icon,
  ai: ai_icon,
  ai_metadata: ai_metadata_icon,
  ai_search: ai_search_icon,
  ai_sparkles: ai_sparkles_icon,
  analyze: analyze_icon,
  annotation_activate: annotation_activate_icon,
  annotation_annotation: annotation_annotation_icon,
  annotation_arrow: annotation_arrow_icon,
  annotation_brush: annotation_brush_icon,
  annotation_brushsize: annotation_brushsize_icon,
  annotation_circle: annotation_circle_icon,
  annotation_color_palette: annotation_color_palette_icon,
  annotation_de_activate: annotation_de_activate_icon,
  annotation_erase: annotation_erase_icon,
  annotation_eraser: annotation_eraser_icon,
  annotation_laser: annotation_laser_icon,
  annotation_line: annotation_line_icon,
  annotation_move: annotation_move_icon,
  annotation_pencil: annotation_pencil_icon,
  annotation_rectangle: annotation_rectangle_icon,
  annotation_redo: annotation_redo_icon,
  annotation_text: annotation_text_icon,
  annotation_undo: annotation_undo_icon,
  archive_archive: archive_archive_icon,
  archive_archived: archive_archived_icon,
  archive_restore: archive_restore_icon,
  arrow_small_e: arrow_small_e_icon,
  arrow_small_n: arrow_small_n_icon,
  arrow_small_s: arrow_small_s_icon,
  arrow_small_w: arrow_small_w_icon,
  aspect_ratio: aspect_ratio_icon,
  asset_delete: asset_delete_icon,
  asset_type_audio: asset_type_audio_icon,
  asset_type_image: asset_type_image_icon,
  asset_type_pdf: asset_type_pdf_icon,
  asset_type_placeholder: asset_type_placeholder_icon,
  asset_type_subclip: asset_type_subclip_icon,
  asset_type_unknown: asset_type_unknown_icon,
  asset_type_video: asset_type_video_icon,
  attachment: attachment_icon,
  automations: automations_icon,
  background: background_icon,
  bell_crossed: bell_crossed_icon,
  broom: broom_icon,
  calendar: calendar_icon,
  calendar_datetime: calendar_datetime_icon,
  checkmark: checkmark_icon,
  chevron_large_isolated_e: chevron_large_isolated_e_icon,
  chevron_large_isolated_n: chevron_large_isolated_n_icon,
  chevron_large_isolated_s: chevron_large_isolated_s_icon,
  chevron_large_isolated_w: chevron_large_isolated_w_icon,
  chevron_small_isolated_e: chevron_small_isolated_e_icon,
  chevron_small_isolated_n: chevron_small_isolated_n_icon,
  chevron_small_isolated_s: chevron_small_isolated_s_icon,
  chevron_small_isolated_w: chevron_small_isolated_w_icon,
  child: child_icon,
  close: close_icon,
  cluster: cluster_icon,
  collection: collection_icon,
  collection_add_to: collection_add_to_icon,
  collection_create_new: collection_create_new_icon,
  collection_opened: collection_opened_icon,
  comment: comment_icon,
  comment_hidden: comment_hidden_icon,
  company_dropbox: company_dropbox_icon,
  company_we_transfer: company_we_transfer_icon,
  company_dailymotion: company_dailymotion_icon,
  company_discord: company_discord_icon,
  company_facebook: company_facebook_icon,
  company_instagram: company_instagram_icon,
  company_snapchat: company_snapchat_icon,
  company_tiktok: company_tiktok_icon,
  company_twitch: company_twitch_icon,
  company_twitter: company_twitter_icon,
  company_x: company_x_icon,
  company_youtube: company_youtube_icon,
  compare: compare_icon,
  conversation: conversation_icon,
  copy: copy_icon,
  credit: credit_icon,
  custom_action: custom_action_icon,
  deletion_clear: deletion_clear_icon,
  deletion_delete: deletion_delete_icon,
  deletion_erase: deletion_erase_icon,
  deletion_remove: deletion_remove_icon,
  dev_api: dev_api_icon,
  display_hide: display_hide_icon,
  display_show: display_show_icon,
  divide: divide_icon,
  drag: drag_icon,
  edit: edit_icon,
  email: email_icon,
  email_error: email_error_icon,
  emoji: emoji_icon,
  enter: enter_icon,
  face_recognition: face_recognition_icon,
  fail: fail_icon,
  favorite_assets: favorite_assets_icon,
  favorite_collections: favorite_collections_icon,
  favorite_saved_searches: favorite_saved_searches_icon,
  favorites_add_to: favorites_add_to_icon,
  favorites_added_to: favorites_added_to_icon,
  file: file_icon,
  file_export: file_export_icon,
  file_proxy: file_proxy_icon,
  filter: filter_icon,
  fit_actual_size: fit_actual_size_icon,
  fit_height: fit_height_icon,
  fit_viewport: fit_viewport_icon,
  fit_width: fit_width_icon,
  folder: folder_icon,
  fr_change_person: fr_change_person_icon,
  gallery: gallery_icon,
  globe: globe_icon,
  go_to: go_to_icon,
  help_description: help_description_icon,
  help_tooltip: help_tooltip_icon,
  history: history_icon,
  home: home_icon,
  iconik_agent_icon: iconik_agent_icon_icon,
  iconik_shield: iconik_shield_icon,
  id: id_icon,
  image_add: image_add_icon,
  index_icon: index_icon_icon,
  isg_pro: isg_pro_icon,
  jobs: jobs_icon,
  key: key_icon,
  keyboard: keyboard_icon,
  language: language_icon,
  link: link_icon,
  link_add: link_add_icon,
  load_down: load_down_icon,
  load_up: load_up_icon,
  loader_circle_done_legacy: loader_circle_done_legacy_icon,
  log_in: log_in_icon,
  log_out: log_out_icon,
  megaphone: megaphone_icon,
  mention: mention_icon,
  menu_context: menu_context_icon,
  menu_hamburger: menu_hamburger_icon,
  message_error: message_error_icon,
  message_success: message_success_icon,
  message_warning: message_warning_icon,
  metadata_dropdown: metadata_dropdown_icon,
  metadata_float: metadata_float_icon,
  metadata_integer: metadata_integer_icon,
  metadata_text: metadata_text_icon,
  metadata_text_area: metadata_text_area_icon,
  minus: minus_icon,
  money_billing: money_billing_icon,
  money_credit_card: money_credit_card_icon,
  money_invoice: money_invoice_icon,
  money_top_up: money_top_up_icon,
  money_transaction: money_transaction_icon,
  money_wallet: money_wallet_icon,
  moon: moon_icon,
  move: move_icon,
  move_bottom: move_bottom_icon,
  move_top: move_top_icon,
  node: node_icon,
  not_modified: not_modified_icon,
  notification: notification_icon,
  open: open_icon,
  padlock_locked: padlock_locked_icon,
  padlock_unlocked: padlock_unlocked_icon,
  page_first_horizontally: page_first_horizontally_icon,
  page_last_horizontally: page_last_horizontally_icon,
  page_number: page_number_icon,
  pages: pages_icon,
  pending: pending_icon,
  pin: pin_icon,
  player_flip_horizontally: player_flip_horizontally_icon,
  player_flop_vertically: player_flop_vertically_icon,
  player_loop: player_loop_icon,
  player_loop_pingpong: player_loop_pingpong_icon,
  player_marker: player_marker_icon,
  player_mixer: player_mixer_icon,
  player_pan: player_pan_icon,
  player_pause: player_pause_icon,
  player_play: player_play_icon,
  player_playback_options: player_playback_options_icon,
  player_playback_speed: player_playback_speed_icon,
  player_time_format: player_time_format_icon,
  player_view_full: player_view_full_icon,
  player_view_normal: player_view_normal_icon,
  player_volume_max: player_volume_max_icon,
  player_volume_meter: player_volume_meter_icon,
  player_volume_mid: player_volume_mid_icon,
  player_volume_no: player_volume_no_icon,
  player_zoom_in: player_zoom_in_icon,
  player_zoom_out: player_zoom_out_icon,
  playlist: playlist_icon,
  plus: plus_icon,
  portal: portal_icon,
  portal_new: portal_new_icon,
  poster: poster_icon,
  present: present_icon,
  printer: printer_icon,
  project: project_icon,
  protected: protected_icon,
  ra: ra_icon,
  ra_approval_requested: ra_approval_requested_icon,
  ra_approval_requested_to_me: ra_approval_requested_to_me_icon,
  ra_approved: ra_approved_icon,
  ra_approved_by_me: ra_approved_by_me_icon,
  ra_rejected: ra_rejected_icon,
  ra_rejected_by_me: ra_rejected_by_me_icon,
  range_in_point: range_in_point_icon,
  range_out_point: range_out_point_icon,
  range_range: range_range_icon,
  recent: recent_icon,
  recent_assets: recent_assets_icon,
  recent_collections: recent_collections_icon,
  refresh: refresh_icon,
  relations: relations_icon,
  reorder: reorder_icon,
  reply: reply_icon,
  reset: reset_icon,
  revert: revert_icon,
  role_groups: role_groups_icon,
  rotate_clockwise: rotate_clockwise_icon,
  rotate_counter_clockwise: rotate_counter_clockwise_icon,
  saved_search: saved_search_icon,
  search: search_icon,
  segment_go_to: segment_go_to_icon,
  selection_items: selection_items_icon,
  selection_items_all: selection_items_all_icon,
  selection_text: selection_text_icon,
  send: send_icon,
  sequence: sequence_icon,
  settings: settings_icon,
  share: share_icon,
  share_by_me: share_by_me_icon,
  share_with_me: share_with_me_icon,
  sidebar_below: sidebar_below_icon,
  sidebar_right: sidebar_right_icon,
  smartphone: smartphone_icon,
  snapshot: snapshot_icon,
  sort: sort_icon,
  sort_newest: sort_newest_icon,
  sort_oldest: sort_oldest_icon,
  star_fill: star_fill_icon,
  statistics: statistics_icon,
  status_generic: status_generic_icon,
  storage_cloud: storage_cloud_icon,
  storage_on_premise: storage_on_premise_icon,
  subtitles: subtitles_icon,
  sum: sum_icon,
  sun: sun_icon,
  sync: sync_icon,
  sync_paused: sync_paused_icon,
  tag: tag_icon,
  tasks: tasks_icon,
  terms: terms_icon,
  text_blockquote: text_blockquote_icon,
  text_bold: text_bold_icon,
  text_editor: text_editor_icon,
  text_italic: text_italic_icon,
  text_list_bullet: text_list_bullet_icon,
  text_list_number: text_list_number_icon,
  text_strikethrough: text_strikethrough_icon,
  text_underscore: text_underscore_icon,
  tier_enterprise: tier_enterprise_icon,
  toggle_on: toggle_on_icon,
  transcoder: transcoder_icon,
  transcription: transcription_icon,
  transfer: transfer_icon,
  translucent: translucent_icon,
  transparency: transparency_icon,
  upgrade: upgrade_icon,
  user_add: user_add_icon,
  user_group: user_group_icon,
  user_type_browse: user_type_browse_icon,
  user_type_power: user_type_power_icon,
  user_type_standard: user_type_standard_icon,
  user_user: user_user_icon,
  versions: versions_icon,
  versions_add_new: versions_add_new_icon,
  video_highlight: video_highlight_icon,
  view_grid: view_grid_icon,
  view_list: view_list_icon,
  webhook: webhook_icon,
};
export type IconName = keyof typeof icons;
